<div class="table-row">
	@let r = getDataRow();
	<div class="font-decimaBold">{{ r.type === 'long_sleep' ? 'Awake' : 'Nap' }}</div>
	<!--	<div>{{ SleepTypesDict[r.type].name }}</div>-->
	<div class="ml-auto"><i class="fa-sharp fal fa-timer mr-1"></i>{{(r.total_sleep_duration / 60 / 60).toFixed(2)}}h
	</div>
	<div><i class="fa-sharp fal fa-lungs mr-1"></i>{{r.average_breath.toFixed()}}bpm</div>
	<div><i class="fa-sharp fal fa-heart-pulse mr-1"></i>{{r.average_heart_rate.toFixed()}}bpm</div>
	<div><i class="fa-sharp fal fa-heart mr-1"></i>{{r.average_hrv?.toFixed()}}hrv</div>
</div>